<div class="input-group">
    <div class="input-group-prepend" *ngIf="inputGroup">
        <span class="input-group-text" *ngIf="inputGroupIcon">
            <i class="{{inputGroupIcon}}"></i>
        </span>
        <span class="input-group-text" *ngIf="inputGroupText">
            {{inputGroupText}}
        </span>
    </div>

    <input 
        [type]="inputType" 
        class="form-control" 
        [name]="name" 
        [id]="id" 
        [required]="required"
        [disabled]="disabled"
        [readonly]="readonly"
        [placeholder]="placeholder"
        #inputTokenfield>
</div>
